// "Hide controls and status" setting — auto-hides the bottom control bar and
// status pill based on mouse activity. Independent of `hideInstructionBar`,
// which is a separate static toggle for the top join-code bar. Persisted as a
// presentation attribute so it survives a page refresh.
export const HIDE_CONTROLS_ATTR = 'hideControls'

const _state = {
  minimisedSubmissionSlides: {}, // { [slideId]: boolean }
  minimisedResultsSlides: {}, // { [slideId]: boolean }
  isMouseIdle: false,
  isMouseNearTopEdge: false,
  isMouseNearTopZone: false,
}

const mutations = {
  SET_SUBMISSION_MINIMISED(state, { slideId, isMinimised }) {
    state.minimisedSubmissionSlides = {
      ...state.minimisedSubmissionSlides,
      [slideId]: isMinimised,
    }
  },
  SET_RESULTS_MINIMISED(state, { slideId, isMinimised }) {
    state.minimisedResultsSlides = {
      ...state.minimisedResultsSlides,
      [slideId]: isMinimised,
    }
  },
  RESET_MINIMISED_STATES(state) {
    state.minimisedSubmissionSlides = {}
    state.minimisedResultsSlides = {}
  },
  SET_MOUSE_IDLE(state, payload) {
    state.isMouseIdle = payload
  },
  SET_MOUSE_NEAR_TOP_EDGE(state, payload) {
    state.isMouseNearTopEdge = payload
  },
  SET_MOUSE_NEAR_TOP_ZONE(state, payload) {
    state.isMouseNearTopZone = payload
  },
}

const actions = {
  setSubmissionMinimisedAction({ commit }, payload) {
    commit('SET_SUBMISSION_MINIMISED', payload)
  },
  setResultsMinimisedAction({ commit }, payload) {
    commit('SET_RESULTS_MINIMISED', payload)
  },
  resetMinimisedStatesAction({ commit }) {
    commit('RESET_MINIMISED_STATES')
  },
  setMouseIdleAction({ commit }, payload) {
    commit('SET_MOUSE_IDLE', payload)
  },
  setMouseNearTopEdgeAction({ commit }, payload) {
    commit('SET_MOUSE_NEAR_TOP_EDGE', payload)
  },
  setMouseNearTopZoneAction({ commit }, payload) {
    commit('SET_MOUSE_NEAR_TOP_ZONE', payload)
  },
  setHideControlsAction({ dispatch, rootState }, payload) {
    return dispatch('presentationAttributeModule/updatePresentationAttributeAction', {
      presentationId: rootState.presentation.id,
      payload: {
        attributeName: HIDE_CONTROLS_ATTR,
        attributeValue: payload,
      },
    }, { root: true })
  },
}

const getters = {
  minimisedSubmissionSlides: (state) => state.minimisedSubmissionSlides,
  minimisedResultsSlides: (state) => state.minimisedResultsSlides,
  isMouseIdle: (state) => state.isMouseIdle,
  isMouseNearTopEdge: (state) => state.isMouseNearTopEdge,
  isMouseNearTopZone: (state) => state.isMouseNearTopZone,
  hideControls: (state, getters, rootState) => Boolean(
    rootState.presentationAttributeModule?.presentationAttribute?.[HIDE_CONTROLS_ATTR],
  ),
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters,
}
